import apiClient from '../client';
import type { Homework, CreateHomeworkPayload, UpdateHomeworkPayload } from '@/types';

export const homeworkApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get<{ data: Homework[]; pagination: { total: number } }>('/admin/homework', { params }).then((r) => r.data),

  getById: (id: number) =>
    apiClient.get<{ data: Homework }>(`/admin/homework/${id}`).then((r) => r.data.data),

  create: (payload: CreateHomeworkPayload) =>
    apiClient.post<{ data: Homework }>('/admin/homework', payload).then((r) => r.data.data),

  update: (id: number, payload: UpdateHomeworkPayload) =>
    apiClient.put<{ data: Homework }>(`/admin/homework/${id}`, payload).then((r) => r.data.data),

  remove: (id: number) =>
    apiClient.delete(`/admin/homework/${id}`),
};

